
import { patchCropPlan } from "@/lib/api";
import { CropPlan } from "@/lib/types/Plan";
import { Vue } from "@/vue";
import { PropType } from "vue";
import { round } from "lodash";

export default Vue.extend({
  props: {
    plan: {
      type: Object as PropType<CropPlan>,
      required: true,
    },
  },
  data() {
    return {
      error: null as any,
      sale_price: this.plan.sale_price,
      target_yield: this.plan.target_yield,
    };
  },
  computed: {
    income() {
      return round(this.sale_price * this.target_yield * this.plan.total_area, 2);
    },
  },
  methods: {
    async onSubmit(event) {
      const data = new FormData(event.target);
      try {
        const { farm, season, id } = this.$props.plan;
        const { target_yield, sale_price } = await patchCropPlan(farm, season, id, data);
        this.$props.plan.target_yield = target_yield;
        this.$props.plan.sale_price = sale_price;
        this.$dialog.close();
      } catch (err) {
        console.log(err);
        this.error = this.$gettext("You gotta use numbers.");
      }
    },
  },
});
